export enum DataQualityClassification {
	GOOD = 'good',
	MODERATE = 'moderate',
	POOR = 'poor',
	UNAVAILABLE = 'unavailable',
	GREAT = 'great',
}

// If you update these you must also update api/automation/queries.py
export enum DataQualityClassificationBounds {
	GREAT = 81,
	GOOD = 61,
	MODERATE = 41,
}
